import React, {
	SetStateAction,
	useState,
	useLayoutEffect,
	useContext
} from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './styles';
import Modal from 'components/Modal';
import { CredentialChild, CredentialFather } from 'types/ProvidersProps';
import { UseTranslationProps } from 'types/UseTranslationProps';
import SimpleInput from 'components/SimpleInput';
import { editProvider } from './reqs';
import SystemNotifyContext from 'context/SystemNotifyContext';
import LoadGeneralContext from 'context/LoadGeneralContext';
import { updateCredentialRecursively } from 'components/ProvidersSettings/function';

interface FormProviderProps {
	isOpen: boolean;
	setIsOpen: React.Dispatch<SetStateAction<boolean>>;
	itemProviderToEdit: null | CredentialChild;
	setItemProviderToEdit: React.Dispatch<SetStateAction<null | CredentialChild>>;
	listProviders: CredentialFather[];
	setListProviders: React.Dispatch<SetStateAction<CredentialFather[]>>;
}

const initialDataForm: CredentialChild = {
	affiliate_id: '',
	created_at: '',
	updated_at: '',
	slug: '',
	credential: null,
	id: '',
	name: ''
};

export default function FormProvider({
	isOpen,
	itemProviderToEdit,
	setIsOpen,
	setItemProviderToEdit,
	listProviders,
	setListProviders
}: FormProviderProps) {
	const { t }: UseTranslationProps = useTranslation();
	const { handleNotify } = useContext(SystemNotifyContext);
	const { setIsOpenLoad, setMessage } = useContext(LoadGeneralContext);

	const [dataForm, setDataForm] = useState(initialDataForm);

	function resetStatesComp() {
		setDataForm(initialDataForm);
		setItemProviderToEdit(null);
	}

	function returnCredential(credential: string | null) {
		if (credential === '' || credential === null) {
			return '';
		}

		if (credential !== null && credential.includes('*')) {
			return '';
		}

		return credential;
	}

	async function handleEditProvider() {
		setIsOpenLoad(true);
		setMessage('Salvando provider');

		const { isSuccess, data } = await editProvider(dataForm);

		if (isSuccess && data !== null) {
			handleNotify('Provider salvo com sucesso', 'success');
			setListProviders(updateCredentialRecursively(listProviders, data));
			setIsOpen(false);
			resetStatesComp();
		} else {
			handleNotify('Erro ao salvar o provider', 'error');
		}

		setIsOpenLoad(false);
	}

	useLayoutEffect(() => {
		if (itemProviderToEdit !== null) {
			setDataForm({
				...itemProviderToEdit
			});
		}
	}, []);

	return (
		<Modal
			isOpenProps={isOpen}
			setIsOpenModal={() => {
				setIsOpen((value) => !value);
				resetStatesComp();
			}}
			title={`${dataForm.name}`}
			buttonClose={false}
		>
			<S.container>
				<SimpleInput
					initialValue={returnCredential(dataForm.credential)}
					label={t('settings.formProvider.credential')}
					getValue={(value: string) => {
						setDataForm((obj) => ({ ...obj, credential: value }));
					}}
				/>
				<S.containerBtns>
					<S.cancel
						data-testid="cancelBtn"
						onClick={() => {
							setIsOpen(false);
							resetStatesComp();
						}}
					>
						{t('cancel')}
					</S.cancel>
					<S.save
						data-testid="saveBtn"
						onClick={() => {
							handleEditProvider();
						}}
					>
						{t('save')}
					</S.save>
				</S.containerBtns>
			</S.container>
		</Modal>
	);
}
